import { memo } from 'react';
import { ActivityIndicator } from 'react-native';
import { LoaderProps } from './Loader.types';
import useStyle from '../../hooks/useStyle';

function Loader(props: LoaderProps) {
  const style = useStyle(props);

  return <ActivityIndicator style={style} />;
}

export default memo(Loader);
